import React from "react";
import { Except } from "type-fest";
import { Selector, SelectorProps } from "./Selector";

/**
 * Wrapper around Selector that only allows a single value to be selected.
 */
export function SingleSelector<T extends string>({
  value,
  onChange,
  ...props
}: SingleSelectProps<T>): React.ReactElement {
  return (
    <Selector
      values={value ? [value] : []}
      onChange={(values) => {
        // will be undefined if values are empty, which can only happen if
        // enableDeselect is true.
        onChange(values[0]);
      }}
      {...props}
    />
  );
}

type SingleSelectBaseProps<T extends string> = Except<
  SelectorProps<T>,
  "onChange" | "values"
> & {
  value: T | undefined;
};

// if enableDeselect is false, then undefined is never provided as a value
// to the onChange callback.
export type SingleSelectProps<T extends string> =
  | (SingleSelectBaseProps<T> & {
      enableDeselect: true;
      onChange: (value: T | undefined) => void;
    })
  | (SingleSelectBaseProps<T> & {
      enableDeselect?: false;
      onChange: (value: T) => void;
    });
